"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    onInit(field) {
        // override default bindings for all text inputs
        (this.state.form.name === 'Register Material')
            && field.set('bindings', 'MaterialTextField');
    },
    onSuccess(fieldset) {
        alert('### see console');
        console.log('Form Values (fieldset)', fieldset.values());
    },
    onError(fieldset) {
        alert('### see console');
        console.log('Form Errors (fieldset)', fieldset.errors());
    },
    onSubmit(field) {
        console.log('-> onSubmit HOOK -', field.path, '- isValid?', field.isValid);
    },
    onClear(field) {
        console.log('-> onClear HOOK -', field.path);
    },
    onReset(field) {
        console.log('-> onReset HOOK -', field.path);
    },
    onChange(field) {
        console.log('-> onChange HOOK -', field.path, field.value);
    },
    onFocus: (field) => {
        console.log('-> onFocus HOOK -', field.path, field.value);
    },
    onBlur: (field) => {
        console.log('-> onBlur HOOK -', field.path, field.value);
    },
    onToggle: (field) => {
        console.log('-> onToggle HOOK -', field.path, field.value);
    },
    onKeyDown: (field) => {
        console.log('-> onKeyDown HOOK -', field.path, field.value);
    }
};
